import React, { useState } from 'react';
import './NotificationModal.css';
import API_BASE_URL from '../../config/api';

const NotificationModal = ({ isOpen, onClose, teamData }) => {
    const [recipient, setRecipient] = useState('team'); // 'team' or athleteId
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    if (!isOpen) return null;

    const handleSend = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(false);

        if (!subject.trim() || !message.trim()) {
            setError('Por favor, preencha o assunto e a mensagem.');
            return;
        }

        setIsSending(true);
        try {
            const token = localStorage.getItem('token');
            const body = {
                teamId: teamData.id,
                athleteProfileId: recipient === 'team' ? null : parseInt(recipient),
                subject,
                message
            };

            const response = await fetch(`${API_BASE_URL}/api/notifications/send`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.message || 'Erro ao enviar notificação.');
            }

            setSuccess(true);
            setSubject('');
            setMessage('');
            setTimeout(() => {
                setSuccess(false);
                onClose();
            }, 2000);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="nm-overlay" onClick={onClose}>
            <div className="nm-modal" onClick={e => e.stopPropagation()}>
                <header className="nm-header">
                    <div className="nm-title-box">
                        <div className="nm-icon"><i className="fas fa-bullhorn"></i></div>
                        <h2>Nova Notificação</h2>
                    </div>
                    <button className="nm-close" onClick={onClose} aria-label="Fechar">
                        <i className="fas fa-times"></i>
                    </button>
                </header>

                <form className="nm-form" onSubmit={handleSend}>
                    <div className="nm-form-group">
                        <label htmlFor="recipient">Destinatário</label>
                        <select
                            id="recipient"
                            className="nm-select"
                            value={recipient}
                            onChange={(e) => setRecipient(e.target.value)}
                        >
                            <option value="team">Toda a Equipa ({teamData?.name})</option>
                            <optgroup label="Atletas">
                                {teamData?.athletes?.map(athlete => (
                                    <option key={athlete.id} value={athlete.id}>
                                        {athlete.name} {athlete.jerseyNumber ? `(#${athlete.jerseyNumber})` : ''}
                                    </option>
                                ))}
                            </optgroup>
                        </select>
                    </div>

                    <div className="nm-form-group">
                        <label htmlFor="subject">Assunto</label>
                        <input
                            type="text"
                            id="subject"
                            className="nm-input"
                            placeholder="Ex: Mudança de horário, Jogo adiado..."
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            required
                        />
                    </div>

                    <div className="nm-form-group">
                        <label htmlFor="message">Mensagem</label>
                        <textarea
                            id="message"
                            className="nm-textarea"
                            rows="5"
                            placeholder="Escreva aqui os detalhes da notificação..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            required
                        ></textarea>
                    </div>

                    {error && <div className="nm-error-msg">{error}</div>}
                    {success && <div className="nm-success-msg">Notificação enviada com sucesso!</div>}

                    <div className="nm-footer">
                        <button type="button" className="nm-btn-cancel" onClick={onClose}>
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="nm-btn-send"
                            disabled={isSending || success}
                        >
                            {isSending ? (
                                <><i className="fas fa-spinner fa-spin"></i> A enviar...</>
                            ) : (
                                <><i className="fas fa-paper-plane"></i> Enviar Notificação</>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NotificationModal;
